var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'bg-white' : _vm.isActive}},[_vm._v(" "+_vm._s(_vm.label)+" "),(_vm.isActive)?_c('DsButton',{staticClass:"p-0",attrs:{"variant":"icon","theme":"dark","icon":_vm.icon.TimesSolid},on:{"click":_vm.slideRemove}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }